import { render, staticRenderFns } from "./Subcategory.vue?vue&type=template&id=6717ee25"
import script from "./Subcategory.vue?vue&type=script&lang=js"
export * from "./Subcategory.vue?vue&type=script&lang=js"
import style0 from "./Subcategory.vue?vue&type=style&index=0&id=6717ee25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports